import { Component, OnDestroy, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';

import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar } from '@angular/material';

import { Location } from '@angular/common';

import { FuseConfigService } from '@fuse/services/config.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';

import { navigation } from 'app/navigation/navigation';

import { AuthService } from "../../../core/auth.service";
import { Router } from '@angular/router';

import { UserService } from '../../../core/user.service';
import { FirebaseUserModel, UserInfo, User } from 'app/core/models/user.model';

import { ProfileFormDialogComponent } from "./profile-form/profile-form.component";

import { Store } from "store";
import { Observable, Subscription } from 'rxjs';
// import { User } from 'firebase';

@Component({
    selector     : 'toolbar',
    templateUrl  : './toolbar.component.html',
    styleUrls    : ['./toolbar.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ToolbarComponent implements OnInit, OnDestroy
{
    userInfo$: Observable<UserInfo>;
    user$: Observable<User>;
    subscription: Subscription;
  
    horizontalNavbar: boolean;
    rightNavbar: boolean;
    hiddenNavbar: boolean;
    languages: any;
    navigation: any;
    selectedLanguage: any;
    userStatusOptions: any[];

    user = new FirebaseUserModel();
    

    // Private
    private _unsubscribeAll: Subject<any>;

    // dialog reference
    dialogUserForm: any;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FuseSidebarService} _fuseSidebarService
     * @param {TranslateService} _translateService
     */
    constructor(
        
        private router: Router,
        private _fuseConfigService: FuseConfigService,
        private _matDialog: MatDialog,
        // @Inject(MAT_DIALOG_DATA) private _data: any,
        private _fuseSidebarService: FuseSidebarService,
        private _translateService: TranslateService,
        private _authService: AuthService,
        public _userService: UserService,
        private location : Location,
        
        private store: Store,
    )
    {
        // Set the defaults
        this.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];

        this.languages = [
            {
                id   : 'en',
                title: 'English',
                flag : 'us'
            },
            {
                id   : 'tr',
                title: 'Turkish',
                flag : 'tr'
            }
        ];

        this.navigation = navigation;

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Subscribe to the config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((settings) => {
                this.horizontalNavbar = settings.layout.navbar.position === 'top';
                this.rightNavbar = settings.layout.navbar.position === 'right';
                this.hiddenNavbar = settings.layout.navbar.hidden === true;
            });

        // Set the selected language from default languages
        this.selectedLanguage = _.find(this.languages, {'id': this._translateService.currentLang});
    
        
            
        // Load temporal user
        // this._userService.getCurrentUser()
        // .then(res => {
        //   if(res.providerData[0].providerId == 'password'){
        //     this.user.image = 'http://dsi-vd.github.io/patternlab-vd/images/fpo_avatar.png';
        //     this.user.name = res.displayName;
        //     this.user.provider = res.providerData[0].providerId;
        //     // return resolve(user);
        //   }
        //   else{
        //     this.user.image = res.photoURL;
        //     this.user.name = res.displayName;
        //     this.user.provider = res.providerData[0].providerId;
        //     // return resolve(user);
        //   }
        // }, err => {
        //   this.router.navigate(['auth/login']);
        // //   return reject(err);
        // })

        this.subscription = this._authService.auth$.subscribe();
        this.user$ = this.store.select<User>('user');
        this.userInfo$ = this.store.select<UserInfo>('userInfo');
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // remove user$ subcription
        this.subscription.unsubscribe();

        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar open
     *
     * @param key
     */
    toggleSidebarOpen(key): void
    {
        this._fuseSidebarService.getSidebar(key).toggleOpen();
    }

    /**
     * Search
     *
     * @param value
     */
    search(value): void
    {
        // Do your search here...
    }

    /**
     * Set the language
     *
     * @param lang
     */
    setLanguage(lang): void
    {
        // Set the selected language for the toolbar
        this.selectedLanguage = lang;

        // Use the selected language for translations
        this._translateService.use(lang.id);
    }

    onEditProfile() {
        this.dialogUserForm = this._matDialog.open(ProfileFormDialogComponent, {
            panelClass: 'profile-form-dialog',
            width: '600px'
        });
    }

    logout(){
        this._authService.doLogout()
        .then((res) => {
        //   this.location.back();

          this.router.navigate(['/auth/login']);
        }, (error) => {
          console.log("Logout error", error);
        });
      }
}
